<ng-container *transloco="let t; read: 'accounts'">
<div id="role" class="fix-action-row modal-body">
  <div class="flex justify-between border-b">
    @if (!editData) {
      <h1 class="text-[25px] font-bold">{{ t('userRoles.addRole') }}</h1>
    }
    @if (editData) {
      <h1 class="text-[25px] font-bold">{{ t('userRoles.editRole') }}</h1>
    }
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>

  <form class="grid grid-cols-2 gap-4 gap-x-10" [formGroup]="roleForm">
    <div>
      <label class="required">{{ t('userRoles.roleCategory') }}</label>
      <mat-radio-group class="flex flex-row" formControlName="RoleGroupId">
        @for (group of roleGroup$ | async; track group) {
          <div>
            <mat-radio-button class="mx-3" [value]="group.id" color="primary">
              <!-- Server-supplied role group name: localized by the API, not by Transloco. -->
              {{ group.name.substring(0, group.name.length - 5) }}
            </mat-radio-button>
          </div>
        }
      </mat-radio-group>
    </div>
    <div class="col-span-full">
      <mat-form-field class="bg-white" appearance="fill">
        <label class="font-normal required" for="RoleName">{{ t('userRoles.roleName') }}</label>
        <input matInput [placeholder]="t('userRoles.roleName')" autocomplete="off" type="text" formControlName="RoleName" maxlength="25"
          required>
      </mat-form-field>
    </div>
    <div class="col-span-full">
      <mat-form-field class="bg-white" appearance="fill">
        <label class="font-normal required" for="RoleDescription">{{ t('common.description') }}</label>
        <input matInput [placeholder]="t('common.description')" autocomplete="off" type="text" formControlName="RoleDescription"
          maxlength="50" required>
      </mat-form-field>
    </div>
  </form>

  <div mat-dialog-actions class="flex justify-end">
    <drdp-btn class="pr-3" color="cancel" mat-button mat-dialog-close>{{ t('common.cancel') }}</drdp-btn>
    <drdp-btn mat-button (click)="onSubmit()" [disabled]="roleForm.invalid" cdkFocusInitial>{{ t('common.save') }}</drdp-btn>
  </div>
</div>
</ng-container>